import React, { useEffect, ReactChild, ReactChildren, useRef, useState } from 'react';
import './MoveInSection.css'
interface AuxProps {
    children: ReactChild | ReactChildren;
  }

  function useMyCustomHook<T extends HTMLElement>() {
    const myRef = useRef<T>(null)

    // do something with the ref, e.g. adding event listeners

    return {ref: myRef}
}

const UpMoveInSection = ({ children }: AuxProps,) => {
    const [isVisible, setVisible] = useState(true);
    const {ref: myElementRef} = useMyCustomHook<HTMLDivElement>()

    useEffect(() => {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => setVisible(entry.isIntersecting));
      });
      if (myElementRef.current !== null) {
          observer.observe(myElementRef.current);
        }
        return () => {
            if (myElementRef.current !== null) {
                observer.unobserve(myElementRef.current)
            }
        };
    }, []);

    return (
      <div
        className={isVisible ? 'move-is-visible up' : 'move-in-section'}
        ref={myElementRef}
      >
        {children}
      </div>
    );
  }

export default UpMoveInSection;
